<template>
  <div id='' class='gPageBorder'>


    <el-dialog :before-close='impClose' class='gDia' :title="$t('app_impdistbt')" v-model="isImp"  :show-close="true">
      
      <el-form class='gForm' label-position="right" ref="channel" label-width="18.5%"  style="margin-top: -10px;">
 
        <el-form-item :label="$t('app_ulfile') + ': '" prop='addr'>
          <el-upload
            class="upload-demo"
            ref="upload"
            name="fileUpload"
            :action="ulurl()"
            :on-success="uploadSuccess"
            :on-change="uploadChange"
            :file-list="fileList"
            :show-file-list="false"
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="downTemp">{{$t('app_downTplFile')}}</el-button>
            
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('app_filename') + ': '" prop='addr'>
          <label style='color: #99A9BF'>{{getFName}}</label>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
          <el-button @click="impClose" >{{$t('lin_btn.cancel')}}</el-button>
         <el-button :disabled="!fileName" type="primary" @click="channelUpload" id="saveBtn">{{$t('app_imp')}}</el-button>
          </div>
    </el-dialog>
    
    <el-row>
      <el-col :span="20" class=''>
        <el-button class='gSgLeftBtn' @click='addChannel' type='primary'>{{$t('lin_global.add_merchant')}}</el-button>

        <el-button class='gSgLeftBtn' @click='importChannel' type='primary'>{{$t('app_impdistbt')}}</el-button>
      </el-col>

      <el-col :span="4" v-show="false">
        <div class='gCtrl'>
          <el-select  v-model="mVal" clearable :placeholder="$t('app_cerType')" @change='selectChange'>
            <el-option
              v-for="item in mType"
              :key="item.vl"
              :label="item.tt"
              :value="item.vl">
            </el-option>
          </el-select>
        </div>
      </el-col>
        

      <el-col :span="4" v-show="true">
        <div class='gSideCtrl'>
          <el-input  :placeholder="$t('lin_global.label_areaid_name')" v-model='queryKey' @keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
        </div>
      </el-col>

    </el-row>

    <el-breadcrumb separator=">" style="margin-left:24px;">
      <el-breadcrumb-item v-for='item,index in mcobjs' :key="index" @click='backTo(index)'>{{item.mechanismname}}</el-breadcrumb-item>
      <label @click="backTo" v-show='mcobjs.length>0' style="cursor:pointer;color:#58B7FF">{{$t('app_dParent')}}</label>
      <!-- {{item.mechanismname}} -->
      <!-- <el-breadcrumb-item>活动列表</el-breadcrumb-item> -->
    </el-breadcrumb>

    <div id='cmData'>
      
      <el-table
        class='tbPoint'
        @row-click='cellClick'
        v-loading.body='loading'
        :data="tableData"
        border
        style="width: 100%">
        <el-table-column
          header-align='center'
          align='left'
          prop="mechanismname"
          style=""
          :label="$t('lin_global.name')"
          width="">
        </el-table-column>
        
        <el-table-column
          header-align='center'
          align='center'
          prop="memo"
          width=''
          :label="$t('app_dParent')">
        </el-table-column>
				<el-table-column
          header-align='center'
          align='center'
          prop="mechanismgrade"
          width=''
          :label="$t('app_level')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="completename"
          width=''
          :label="$t('app_contact')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="mechanismcode"
          width=''
          :label="$t('app_contactPhone')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="mechanismaddre"
          width=''
          :label="$t('app_addres')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="terminalNum"
          :label="$t('app_deviceNum')"
          width="">
        </el-table-column>
        <!-- <el-table-column
          header-align='center'
          align='center'
          prop="mechanismaddre"
          width=''
          :label="$t('app_cerType')">
          <template slot-scope='scope'>
            <el-tag v-if="scope.row.certType === 0" type="success" size="mini">{{$t('app_cerMgSelf')}}</el-tag>
            <el-tag v-if="scope.row.certType === 1" type="warning" size="mini">{{$t('app_cerMgOther')}}</el-tag>
            <el-tag v-if="scope.row.certType === 2" type="info" size="mini">{{$t('app_cerMgCustomer')}}</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column
          header-align='center'
          align='center'
          prop="operate"
          width='106'
          :label="$t('app_operate')">
          <template slot-scope='scope'>
           

            <el-tooltip v-show="true" class="item" effect="dark" :content="$t('app_detail')" placement="top">
              <el-button type='text' @click='toDetail(scope.row)'><i class="fa fa-info-circle" style=""></i></el-button>
            </el-tooltip>

            <el-tooltip v-show="scope.row.superid !== '0'" class="item" effect="dark" :content="$t('app_edit')" placement="top">
              <el-button type='text' @click='editChannel(scope.row)'><i class="fa fa-pencil" style=""></i></el-button>
            </el-tooltip>

            <el-tooltip v-show="scope.row.superid !== '0'" class="item" effect="dark" :content="$t('app_del')" placement="top">
              <el-button type='text' @click='deleteChannel(scope.row)'><i class="fa fa-trash" style="color:#FF4949"></i></el-button>
            </el-tooltip>

          </template>
        </el-table-column>
      </el-table>
      <div class="gPgDiv">

        <el-pagination
        class='gPg'
        v-show='true'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="page"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<style>
  #channelMg{background:none;border:0px solid red;}
</style>

<script>
  export default{
    data () {
      return {
        fileName: '',
        fileList: [],
        isImp: false,
        tableData: [],
        mType: [
          {tt: this.$t('app_cerMgSelf'), vl: '0'},
          {tt: this.$t('app_cerMgOther'), vl: '1'}
        ],
        mVal: '',
        queryKey: '',
        loading: 0,
        total: 0,
        page: 1,
        mcobjs: []
      }
    },
    computed: {
      getFName () {
        return this.fileName? this.fileName: this.$t('app_impmctip')
      }
    },
    methods: {
      
      getNewestList () {
        if (this.mcobjs.length == 0) {
          this.getList()
        } else {
          var mid = this.mcobjs[this.mcobjs.length - 1].mechanismid
          mid = mid == 0? '' : mid
          this.getList(mid)
        }
      },
      saveStore () {
        this.$store.dispatch('setMCPath', this.mcobjs)
      },
      getStore () {
        if(this.$store.getters.isRcMcpath) {
          this.mcobjs = this.$store.getters.mcpath
          if (this.mcobjs.length == 0) {
            this.getList()
            return
          } 
          this.getNewestList()
        } else {
          this.getList()
        }
      },
      backTo () {
        this.mcobjs.pop()
        if (this.mcobjs.length == 0) {
          this.getList()
          return
        }
        
        this.getNewestList()
      },
      pushMc (row) {
        var mid = row.mechanismid
        this.mcobjs.push(row)
        this.getList(mid)
      },
      toDetail (row) {
        this.saveStore()
        this.$setWObj("appChannelDetail", row);
        this.$router.push({ path: "/channels/channel-detail" });
      },
      makesp (level) {
        var ivl = 20
        var ilv = parseInt(level)
        return "margin-left:" + ivl * ilv + 'px;'
        // var pstr = ''
        // for (var i=0;i<level;i++) {
        //   pstr+='——'
        // }
        // return pstr
      },
      ulurl () {
       var url = this.$mcUploadUrl + '?token=' + localStorage.user + '&language=' + localStorage.system_lang
      //  alert(url)
       return url
      },
      uploadChange (file) {
        if (this.isImp) {
          this.fileName = file.name
        } else {
          this.fileName = ''
        }
      },
      uploadSuccess (res,flie) {
        if(res.status == 200){
          //this.$message.success(res.message);
          this.$notify({
            title: this.$t('terminal.list.notify_title'),
            message: res.message,
            type: 'success',
            duration: 6000
          })
          this.impClose()
          // this.getList()
          this.getNewestList()
        }else{
          this.$notify.error({
            title: this.$t('terminal.list.notify_title'),
            message: res.message,
            duration: 6000
          });
          //this.$message.error(res.message);
        }
      },
      channelUpload () {
        this.$refs.upload.submit()
      },
      downTemp () {
        window.open(this.$mcTempUrl)
      },
      impClose () {
        this.$refs.upload.clearFiles()
        this.isImp = false
        this.fileName = ''
      },
      importChannel () {
        this.isImp = true
      },
      query () {
        // this.getList()
        this.getNewestList()
      },
      cellClick(row, ev, col) {
        var label = col.label
        if (!label) return
        if (label === this.$t("app_operate")) {
          return;
        } else {
          this.queryKey = ''
          this.pushMc(row)
        }
      },
      selectChange () {
        // this.getList()
        this.getNewestList()
      },
      pageSelect (index) {
        this.page = index
        // this.getList()
        // this.$setWPage('dataChannelPage', index)
        this.getNewestList()
      },
      pageSized (val) {
        this.$gRow = val
        // this.getList()
        this.getNewestList()
      },
      editChannel (row) {
        this.saveStore()
        this.$setWObj('editDataConfig', {type: 1, pageType: 0, data: row})
        // /channels/editchannel
        //this.$router.push({name: this.$t('menu.dataManageSub.editChannel')})
        this.$router.push({path: '/channels/editchannel'})
      },
      deleteChannel (row) {
       
        this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', () => {
          // sure
          this.loading = 1
          this.$deleteChannel(row.mechanismid, (res) => {
            this.loading = 0
            if (res.status === 200) {
              // this.getList()
              this.getNewestList()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
          })
        })
      },
      addChannel () {
        this.saveStore()
        this.$setWObj('editDataConfig', {type: 0})
        // /channels/newchannel
        // this.$router.push({name: this.$t('menu.dataManageSub.newChannel')})
        this.$router.push({path: '/channels/newchannel'})
      },
      getList (mcid) {
        
        this.loading = 1
        //////0自1代
        var type = this.mVal? this.mVal : ''
        var name = this.queryKey?this.queryKey: ''
        var mid = mcid?mcid:''
        
        this.$getChannelList(this.$gRow, this.page, mid, type, name, (res) => {
          this.loading = 0
          
          this.$getMcTypeInfo(res.data.mechanismid, res => {

          }, '')
          
          if (res.status === 200) {
            this.total = res.total
            this.tableData = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
        })
        
        // this.$parentChannel(1, 10, (res) => {
        //   this.loading = 0
        //   // console.log(res.data)
        //   if (res.status === 200) {
        //     this.tableData = [res.data[0]]
        //   } else {
        //     this.$message(res.message)
        //   }
        // }, () => {
        //   this.loading = 0
        // })
      }
    },
    mounted () {
     
      this.getStore()
    }
  }
</script>



// WEBPACK FOOTER //
// channelManage.vue?77a348c5